import { otherApiClient } from ".";
export const getMyCoupons = async ()=>{
    const { data  } = await otherApiClient.market("/coupons/user");
    return data;
};
// 사용가능 쿠폰 목록 (페이지네이션 X). 정렬: expiredAt ASC, id DESC
export const getAvailableUserCoupons = async (params)=>{
    const { data  } = await otherApiClient.market("/coupons/user/available", {
        params
    });
    return data;
};
// 사용/기간만료 쿠폰 목록 (offset/limit). 정렬: expiredAt DESC, id DESC
export const getExpiredUserCoupons = async (params)=>{
    const { data  } = await otherApiClient.market("/coupons/user/expired", {
        params
    });
    return data;
};
export const getHandoutCoupons = async (params)=>{
    const { data  } = await otherApiClient.market("/coupons", {
        params
    });
    return data;
};
export const getCouponFilters = async ()=>{
    const { data  } = await otherApiClient.market("/coupons/receivable/filters");
    return data;
};
export const getReceivableCoupons = async (param)=>{
    let { subject , category  } = param;
    const { data  } = await otherApiClient.market("/coupons/receivable", {
        params: {
            subject,
            category
        }
    });
    return data;
};
// 쿠폰 받기
export const postUserCoupon = async (couponId)=>{
    const { data  } = await otherApiClient.market.post("/coupons/user", {
        couponId
    });
    return data;
};
export const patchUserCoupon = async (request)=>{
    const { data  } = await otherApiClient.market.patch("/coupons/user/orders", {
        ...request
    });
    return data;
};
export const postProductCoupon = async (productId)=>{
    const { data  } = await otherApiClient.market.post("/coupons/products", {
        productId
    });
    return data;
};
export const getPodCoupons = async ()=>{
    const { data  } = await otherApiClient.market("/coupons/pod");
    return data;
};
export const getDeliveryCoupons = async (type)=>{
    const { data  } = await otherApiClient.market("/coupons/delivery".concat(type ? "?productType=".concat(type) : ""));
    return data;
};
export const getAuthorCoupons = async (authorId)=>{
    const { data  } = await otherApiClient.market("/coupons/author", {
        params: {
            authorId
        }
    });
    return data;
};
